const Addon = () =>
  import(
    /* webpackChunkName: "base-info-addon" */ '@/pages/base-info/order-properties/addon/index.vue'
  )
const CreateAddon = () =>
  import(
    /* webpackChunkName: "base-info-addon" */ '@/pages/base-info/order-properties/addon/create.vue'
  )
const EditAddon = () =>
  import(
    /* webpackChunkName: "base-info-addon" */ '@/pages/base-info/order-properties/addon/edit.vue'
  )

export default {
  path: 'addon',
  meta: {
    label: 'addon',
    auth: 'addon'
  },
  component: {
    name: 'Addon',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPropertyAddon',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Addon
    },
    {
      name: 'BaseInfoCreatePropertyAddon',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateAddon
    },
    {
      name: 'BaseInfoEditPropertyAddon',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditAddon,
      props: true
    }
  ]
}
